import Cookie from 'vue-cookie'
import api from '@/api'
import notifier from '@/notifier'
import { getAllUrlParams } from '@/helper'
import * as jwt from 'jsonwebtoken'

export default {
  namespaced: true,
  state: {
    user: {},
    logging: false,
    hasAccessError: false
  },
  actions: {
    addUser ({ state, commit }, user) {
      const merchantIdentifier = jwt.decode(Cookie.get('token')).merchant.identifier
      for (let x in user.merchants) {
        user.merchants[x]['selected'] = false
        if (merchantIdentifier === user.merchants[x]['identifier'] || (x <= 0 && merchantIdentifier === null)) {
          user.merchants[x]['selected'] = true
          Cookie.set('merchant', user.merchants[x]['identifier'])
        }
      }
      commit('addUser', user)

      if (getAllUrlParams().merchant) {
        this._actions['user/changeMerchant'][0](getAllUrlParams().merchant)
      }
    },
    changeMerchant ({ state, commit }, identifier) {
      for (let x in state.user.merchants) {
        state.user.merchants[x]['selected'] = false
        if (state.user.merchants[x]['identifier'] === identifier) {
          state.user.merchants[x]['selected'] = true
          this._actions['user/login'][0](identifier)
          Cookie.delete('merchant')
          Cookie.set('merchant', state.user.merchants[x]['identifier'])
        }
      }
      let currentUrl = window.location.href

      if (currentUrl.indexOf('?') !== -1) {
        currentUrl = currentUrl.replace(currentUrl.substr(currentUrl.indexOf('?'), 11 + identifier.length), '')
        window.location.replace(currentUrl)
        return
      }

      window.location.reload()
    },
    async login ({ state, commit }, merchant) {
      commit('logging', true)

      const token = Cookie.get('token')

      let merchantIdentifier = null
      try {
        merchantIdentifier = token ? jwt.decode(token).merchant.identifier : null
      } catch (e) {
        Cookie.delete('token')
        Cookie.delete('merchant')
        api.redirectToLogarme()
        return
      }

      if (token === null || merchant || merchantIdentifier !== Cookie.get('merchant')) {
        const accessToken = getAllUrlParams().access_token

        if (accessToken === undefined) {
          api.redirectToLogarme()
          return
        }

        try {
          const auth = await api.authenticate(accessToken)
          Cookie.set('token', auth.data.authentication.token)
          this._actions['user/addUser'][0](auth.data)
        } catch (error) {
          if (error.response) {
            switch (error.response.headers['www-authorization']) {

              case 'app':
                commit('hasAccessError', true)
                commit('logging', false)
                break

              case 'logarme':
                api.redirectToLogarme()
            }
          }
        }
      }

      const redirectParams = getAllUrlParams()

      if (redirectParams && redirectParams.force_login !== undefined && Number(redirectParams.force_login)) {
        const accessToken = getAllUrlParams().access_token

        try {
          const auth = await api.authenticate(accessToken)
          Cookie.set('token', auth.data.authentication.token)
          this._actions['user/addUser'][0](auth.data)
        } catch (error) {
          if (error.response) {
            switch (error.response.headers['www-authorization']) {

              case 'app':
                commit('hasAccessError', true)
                commit('logging', false)
                break

              case 'logarme':
                api.redirectToLogarme()
            }
          }
        }
      }

      commit('logging', false)
    },
    logout ({ state, commit }) {
      Cookie.delete('token')
      api.redirectToLogoutLogarme()
    },
    async unlinkUser ({ state, commit }, user) {
      try {
        await api.unlinkUser(user.email)
      } catch (err) {
        let message = 'Falha ao desvincular usuário.'

        if (err.response) {
          message = err.response.data.message
        }

        if (err.response.status === 401) {
          message = 'Falha ao desvincular email.'
        }

        notifier.error(message, 'Erro')
      }
    },
    async linkUser ({ state, commit }, email) {
      try {
        await api.linkUser(email)
        notifier.success('Email vinculado com sucesso!', 'Sucesso')
      } catch (err) {
        let message = 'Falha ao vincular email.'

        if (err.response) {
          message = err.response.data.message
        }

        if (err.response.status === 409) {
          message = 'Email já vinculado!'
        }

        notifier.error(message, 'Erro')
      }
    }
  },
  getters: {
    user: state => state.user
  },
  mutations: {
    logging (state, flag) {
      state.logging = flag
    },
    hasAccessError (state, flag) {
      state.hasAccessError = flag
    },
    addUser (state, userToAdd) {
      state.user = userToAdd
      state.fetching = false
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js